// Capitalizes each word (handles French names with hyphens/apostrophes: "jean-pierre" -> "Jean-Pierre").
export function toTitleCase(value: string): string {
    return value
        .toLowerCase()
        .replace(/(^|[\s'-])([a-zà-ÿ])/g, (_match, sep, letter) => sep + letter.toUpperCase());
}

// Capitalizes only the first letter, leaving the rest untouched (place names like "La Chaux-de-Fonds"
// have irregular internal capitalization that a naive title-case would break).
export function toSentenceCase(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
}
